export default "__VITE_ASSET__CMg$gqLC__"